<template>
  <div>
    <div
      v-if="!documents.length && !isAdding"
      class="bg-secondary-3 p-3 mt-4 rounded"
    >
      <div>
        <div class="upload-file-button__container">
          <div class="panel-row-without-selector p-4">
            <div class="col-12 text-center">
              <button
                v-if="!readOnly || !addingAddendum"
                class="btn bg-light-white col-12 col-md-4"
                @click="isAdding = true"
              >
                <em class="fas fa-file-plus pr-4 text-green" />
                <span class="text-button-add-document">
                  Presione aquí para anejar documento
                </span>
              </button>
              <div v-else class="text-center">
                <strong>No hay documentos anejados</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <bid-document-row
        v-for="(document, index) in documents"
        :key="index"
        :adding-addendum="addingAddendum"
        :document="document"
        :index="index"
        :read-only="readOnly"
        @on-download="onDownload"
        @on-remove="onRemove"
      />
    </div>
    <div v-if="isAdding" class="bg-secondary-3 p-3 mt-3 rounded">
      <validation-observer ref="documentObserver" class="row mx-2 " tag="div">
        <div class="col-md-4 col-sm-6">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              id="inputDocumentName"
              v-model="model.documentName"
              custom-error-msg="Favor ingresar nombre del documento."
              :error="errors[0]"
              label="Nombre del Documento:"
            />
          </validation-provider>
        </div>
        <div
          class="col-md-4 col-sm-6 "
          :class="model.file && 'd-flex justify-content-center'"
        >
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-file-input
              ref="fileUpload"
              v-model="model.file"
              :accept="allowedFiles"
              class="mt-4 pt-1"
              custom-error-msg="Favor seleccionar un documento."
              display-style="normal"
              :error="errors[0]"
              label=""
              label-position="left"
              :max-size="100"
              :on-download="() => {}"
              required
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <div class="mt-4 text-right">
            <action-button
              id="btnCancel"
              i="fas fa-times-circle"
              variant="outline-danger btn-cancel danger m-2"
              @click="closeAdding"
            >
              Cancelar
            </action-button>
            <action-button
              id="btnAdd"
              i="fas fa-file-plus"
              variant="success pl-4 pr-4"
              @click="onAdd"
            >
              Añadir
            </action-button>
          </div>
        </div>
      </validation-observer>
    </div>
    <div
      v-if="documents.length > 0 && !isAdding && (!readOnly || !addingAddendum)"
      class="d-flex justify-content-end mt-3"
    >
      <action-button
        i="fas fa-file-plus"
        variant="success"
        @click="isAdding = true"
      >
        Añadir
      </action-button>
    </div>
  </div>
</template>

<script>
import CustomFileInput from 'CustomFileInput';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import BidDocumentRow from './BidDocumentRow';
import service from '@/modules/app/api';

import alert from '@/mixins/alert.mixin';

export default {
  name: 'BidDocument',
  components: {
    CustomFileInput,
    CustomInput,
    ActionButton,
    BidDocumentRow,
  },
  mixins: [alert],
  props: {
    documents: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    addingAddendum: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    model: {
      documentName: null,
      file: null,
    },
    isAdding: false,
  }),
  computed: {
    allowedFiles() {
      return ['.pdf', '.docx', '.xlsx', '.png'].join(',');
    },
  },
  methods: {
    async onAdd() {
      const isValid = await this.$refs.documentObserver.validate();
      if (!isValid) return;

      this.$emit('on-add-document', {
        documentName: this.model.documentName,
        file: this.model.file,
      });

      this.closeAdding();
    },
    async onDownload(document) {
      if (document.documentId != undefined) {
        service
          .downloadDocumentByAttachmentId(document.documentId)
          .catch((error) => {
            this.ShowToast('', error.response.data.message, 'error');
          });
      } else {
        service.downloadFileInline(document.file);
      }
    },
    async onRemove(index) {
      this.$emit('on-remove-document', index);
    },
    closeAdding() {
      this.isAdding = false;
      this.model.documentName = null;
      this.model.file = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';
</style>
